import { AxiosResponse } from 'axios';
import { IUserRequest, IUser, IUserStatus, IUserStatusRequest } from '../../types';
import { Service } from 'typedi';
import { axios } from '../axios';
import { ShowNotification } from '../ShowNotification';

@Service()
export class MembersRequest {
  @ShowNotification()
  getMembers(excludeCurrentUser: boolean = true): Promise<AxiosResponse<IUserRequest[]>> {
    return axios.post(`user/filter`, {
      excludeCurrentUser
    });
  }

  @ShowNotification()
  getMembersStatus(interval: IUserStatusRequest): Promise<AxiosResponse> {
    return axios.post(`user/state`, interval);
  }
}
